import { render, staticRenderFns } from "./CountryOpening.vue?vue&type=template&id=1475eff9&scoped=true&"
import script from "./CountryOpening.vue?vue&type=script&lang=js&"
export * from "./CountryOpening.vue?vue&type=script&lang=js&"
import style0 from "./CountryOpening.vue?vue&type=style&index=0&id=1475eff9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475eff9",
  null
  
)

export default component.exports